import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const createPublicMysteryShopper = async (params: any) => {
  const url = endpoints.MYSTERY_SHOPPER_PUBLIC_CREATE;
  const { data: response } = await axios.post(url, params);
  return response;
};

const getMysteryShopperList = async (params: any) => {
  const url = endpoints.MYSTERY_SHOPPER_LIST;
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });
  return response;
};

const assignMysteryShopperEmployees = async (params: {
  mystery_shopper_id: number;
  employee_ids: number[];
}) => {
  const url = endpoints.MYSTERY_SHOPPER_EMPLOYEES;
  const { data: response } = await axios.put(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const service = {
  createPublicMysteryShopper,
  getMysteryShopperList,
  assignMysteryShopperEmployees,
};

export default service;
